import { PerspectiveApi, PerspectiveClient } from '../http/api'
import { useRequest } from 'ahooks'

const usePerspective = () => {
    const perspectiveClient: PerspectiveApi = new PerspectiveClient()
    const { data: perspectivesData } = useRequest(async () => await perspectiveClient.list(), {
        cacheKey: 'live-perspectives'
    })

    const findPerspective = perspectiveId => {
        if (!perspectiveId) {
            console.error("Can't find perspectiveId: " + perspectiveId)
        }

        return perspectivesData?.data?.find(ele => ele?.id === perspectiveId)
    }

    return { perspectives: perspectivesData?.data, findPerspective }
}

export default usePerspective
